import editTabsMixin from '../../mixins/editTabsMixin'

const TAB_KEY = 'assignedDrivers'
const DATA_KEY = 'people'
export default {
  mixins: [
    editTabsMixin
  ],

  data () {
    return {
      assignedDriversTabKey: TAB_KEY
    }
  },

  computed: {
    assignedDriversEditConfig () {
      return {
        title: this.$t('base/user.assigned_drivers'),
        key: TAB_KEY,
        apiConfig: {
          get: {
            module: 'base',
            route: `user/${this.$route.params.id}/assigned-drivers`
          },
          post: {
            module: 'base',
            route: `user/${this.$route.params.id}/assigned-drivers`
          }
        },
        modifyDataBeforeSend: (event) => this.modifyAssignedDriversData(event),
        hiddenFormKeys: [
          DATA_KEY
        ],
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('base/user.assigned_drivers'),
            showBackButton: {
              onGoBack: () => this.goBack()
            }
          },
          {
            component: this.personPickerComponent,
            dataKey: DATA_KEY,
            inputFieldConfig: {
              label: this.$t('base/user.assigned_drivers')
            },
            treeviewConfig: {
              selectable: true,
              activatable: true
            }
          }
        ]
      }
    }
  },

  methods: {
    modifyAssignedDriversData (event) {
      const { copiedData } = event || {}

      if (copiedData?.[DATA_KEY]?.length) {
        copiedData[DATA_KEY] = copiedData[DATA_KEY].map(item => item?.id || item).filter(item => item)
      }
      else {
        delete copiedData[DATA_KEY]
      }

      return copiedData
    }
  }
}
